import { sstPreviewUrl } from "./sstPreviewUrl";

export const URL_WEB = sstPreviewUrl(process.env.NEXT_PUBLIC_WEB_URL);
